import { HttpRequestStatus } from "src/shared/types/statuses";
import { HouseholdClaim } from "src/containers/household-claim/models/claim.model";

export interface HouseholdClaimState {
    status: HttpRequestStatus;
    claims: HouseholdClaim[];
    error?: Error;
}

export const householdClaimsState: HouseholdClaimState = {
    status: HttpRequestStatus.NONE,
    claims: [],
    error: undefined,
};
